import { render, staticRenderFns } from "./EditFamilyDetails.vue?vue&type=template&id=07f5725e"
import script from "./EditFamilyDetails.vue?vue&type=script&lang=js"
export * from "./EditFamilyDetails.vue?vue&type=script&lang=js"
import style0 from "./EditFamilyDetails.vue?vue&type=style&index=0&id=07f5725e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports